import cn from 'classnames';

import ImageField from '@/shared/components/CardInfo/Field/ImageField';
import LinkField from '@/shared/components/CardInfo/Field/LinkField';
import PeriodField from '@/shared/components/CardInfo/Field/PeriodField';
import {CardDetail} from '@/shared/models/card';
import {nl2br} from '@/shared/utils/nl2br';

interface Props extends Omit<CardDetail, 'value'> {
  className?: string;
  value?: string | {from: string; to: string | null};
}

const CardInfoField = ({title, value, link, image, className, imageHeight, imageWidth}: Props) => {
  const isPeriod = typeof value === 'object' && 'from' in value && 'to' in value;
  const hasImage = !!image;
  const hasLink = !!link;

  const renderField = () => {
    if (isPeriod) {
      return <PeriodField value={value} />;
    }
    if (hasImage) {
      return <ImageField src={image} value={value} height={imageHeight} width={imageWidth} />;
    }
    if (hasLink) {
      return <LinkField link={link} value={value} />;
    }

    return <dd>{value ? nl2br(value) : '정보 없음'}</dd>;
  };

  return (
    <dl className={cn('list_def type4', className)} role="text">
      <dt>{title}</dt>
      {renderField()}
    </dl>
  );
};

export default CardInfoField;
